import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { I18nProvider } from './contexts/I18nContext';
import { CreditConfigProvider } from './contexts/CreditConfigContext';
import Layout from './components/Layout';
import Catoo from './components/Catoo/Catoo';
import Login from './components/Login';
import OAuth2RedirectHandler from './components/OAuth2RedirectHandler';
import GlobalLoginExpiredHandler from './components/GlobalLoginExpiredHandler/GlobalLoginExpiredHandler';

import Showcase from './components/Showcase';
import ShareView from './components/ShareView';
import Pricing from './components/Pricing';
import CreationRecord from './components/CreationRecord';
import ImageUpscaler from './components/ImageUpscaler';
import AiWorkbench from './components/AiWorkbench';
import AiToolsWorkbench from './components/AiToolsWorkbench';
import PopArtPortrait from './components/AiToolCollection/PopArtPortrait';
import AnimeStyle from './components/AiToolCollection/AnimeStyle';
import OilPainting from './components/AiToolCollection/OilPainting';
import ProfessionalPortrait from './components/AiToolCollection/ProfessionalPortrait';
import EmojiPack from './components/AiToolCollection/EmojiPack/EmojiPack';
import WeddingPhoto from './components/AiToolCollection/WeddingPhoto';
import GroupPhoto from './components/AiToolCollection/GroupPhoto';
import Watercolor from './components/AiToolCollection/Watercolor';
import Sketch from './components/AiToolCollection/Sketch';
import ImageMatting from './components/AiToolCollection/ImageMatting/ImageMatting';
import Cyberpunk from './components/AiToolCollection/Cyberpunk';
import FaceSwap from './components/AiToolCollection/FaceSwap';
import WorldView from './components/AiToolCollection/WorldView/WorldView';
import LogoGeneration from './components/AiToolCollection/LogoGeneration';
import IdPhotoGeneration from './components/AiToolCollection/IdPhotoGeneration';
import PhotoRestoration from './components/AiToolCollection/PhotoRestoration';
import Sora2 from './components/VideoGeneration/SoraGenerationPage/Sora2';
import Veo2 from './components/VideoGeneration/VeoGenerationPage/Veo2';
import Wan from './components/VideoGeneration/WanGenerationPage/Wan';
import Mv from './components/VideoGeneration/MvGenerationPage';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';

import PaymentSuccess from './components/PaymentSuccess';
import PaymentCallback from './components/PaymentCallback/PaymentCallback';
import PersonalCenter from './components/PersonalCenter';
import './App.css';

const AppContent = () => {
  const { user, loading } = useAuth();

  // 只在初始认证检查时显示全局loading，避免与页面级loading冲突
  if (loading && !user && !localStorage.getItem('token')) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>初始化中...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
      <Route path="/login" element={
        user ? <Navigate to="/" replace /> : <Login />
      } />

      <Route path="/pricing" element={
        <Layout><Pricing /></Layout>
      } />
      <Route path="/share" element={
        <Layout><ShareView /></Layout>
      } />
      <Route path="/showcase" element={
        <Layout><Showcase /></Layout>
      } />
      <Route path="/records" element={
        <Layout><CreationRecord /></Layout>
      } />
      <Route path="/creation-record" element={
        <Layout><CreationRecord /></Layout>
      } />
      <Route path="/credits" element={
        user ? <Navigate to="/personal-center" replace /> : <Layout><PersonalCenter /></Layout>
      } />
      <Route path="/privacy-policy" element={
        <Layout><PrivacyPolicy /></Layout>
      } />
      <Route path="/dashboard" element={
        <Layout><Catoo /></Layout>
      } />
      <Route path="/image-upscaler" element={
        <Layout><ImageUpscaler /></Layout>
      } />
      <Route path="/referrals" element={
        user ? <Navigate to="/personal-center" replace /> : <Layout><PersonalCenter /></Layout>
      } />
      <Route path="/ai-workbench" element={
        <Layout><AiWorkbench /></Layout>
      } />
      <Route path="/ai-tools-workbench" element={
        <Layout><AiToolsWorkbench /></Layout>
      } />
      <Route path="/ai-tools/professional-portrait" element={
        <Layout><ProfessionalPortrait /></Layout>
      } />
      <Route path="/ai-tools/wedding-photo" element={
        <Layout><WeddingPhoto /></Layout>
      } />
      <Route path="/ai-tools/group-photo" element={
        <Layout><GroupPhoto /></Layout>
      } />
      <Route path="/ai-tools/emoji-pack" element={
        <Layout><EmojiPack /></Layout>
      } />
      <Route path="/ai-tools/pop-art-portrait" element={
        <Layout><PopArtPortrait /></Layout>
      } />
      <Route path="/ai-tools/anime-style" element={
        <Layout><AnimeStyle /></Layout>
      } />
      <Route path="/ai-tools/oil-painting" element={
        <Layout><OilPainting /></Layout>
      } />
      <Route path="/ai-tools/watercolor" element={
        <Layout><Watercolor /></Layout>
      } />
      <Route path="/ai-tools/sketch-style" element={
        <Layout><Sketch /></Layout>
      } />
      <Route path="/ai-tools/cyberpunk" element={
        <Layout><Cyberpunk /></Layout>
      } />
      <Route path="/ai-tools/world-view" element={
        <Layout><WorldView /></Layout>
      } />
      <Route path="/ai-tools/face-swap" element={
        <Layout><FaceSwap /></Layout>
      } />
      <Route path="/ai-tools/logo-generation" element={
        <Layout><LogoGeneration /></Layout>
      } />
      <Route path="/ai-tools/id-photo-generation" element={
        <Layout><IdPhotoGeneration /></Layout>
      } />
      <Route path="/ai-tools/photo-restoration" element={
        <Layout><PhotoRestoration /></Layout>
      } />
      <Route path="/ai-tools/image-matting" element={
        <Layout><ImageMatting /></Layout>
      } />
      <Route path="/ai-tools/veo-video-generator" element={
        <Layout><Veo2 /></Layout>
      } />
      <Route path="/ai-tools/sora-video-generator" element={
        <Layout><Sora2 /></Layout>
      } />
      <Route path="/ai-tools/wan-video-generator" element={
        <Layout><Wan /></Layout>
      } />
      <Route path="/ai-tools/mv-generator" element={
        <Layout><Mv /></Layout>
      } />
      <Route path="/payment/success" element={
        <PaymentSuccess />
      } />
      <Route path="/payment/stripe/success" element={
        <PaymentCallback />
      } />
      <Route path="/payment/stripe/cancel" element={
        <PaymentCallback />
      } />
      <Route path="/payment/paypal/success" element={
        <PaymentCallback />
      } />
      <Route path="/payment/paypal/cancel" element={
        <PaymentCallback />
      } />
      <Route path="/personal-center">
        <Route index element={<PersonalCenter />} />
        <Route path="*" element={<PersonalCenter />} />
      </Route>
      <Route path="/" element={
        <Layout><Catoo /></Layout>
      } />
    </Routes>
  );
};

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CreditConfigProvider>
          <div className="App">
            <AppContent />
            <GlobalLoginExpiredHandler />
          </div>
        </CreditConfigProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
